
export default {
    props: ['formValidator'],
}
